import {Loader2} from "lucide-react";
import * as React from "react";
import {useTranslation} from "react-i18next";

import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";

type ConfirmationModalProps = {
  open: boolean;
  title: string;
  loading?: boolean;
  disableConfirmButton?: boolean;
  confirmButtonClassName?: string;
  confirmButtonLabel: string;
  onClose: () => void;
  onConfirm: () => void;
  text?: string;
  children?: React.ReactNode;
};

export default function ConfirmationModal({
  open,
  title,
  loading,
  disableConfirmButton = false,
  text,
  confirmButtonClassName,
  confirmButtonLabel,
  children,
  onClose,
  onConfirm,
}: ConfirmationModalProps) {
  const {t} = useTranslation("common");

  return (
    <AlertDialog
      open={open}
      // onOpenChange={(o) => !o && onClose()}
    >
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>{title}</AlertDialogTitle>
          {text != null && text !== "" && (
            <AlertDialogDescription>{text}</AlertDialogDescription>
          )}
        </AlertDialogHeader>
        {children}
        <AlertDialogFooter>
          <AlertDialogCancel onClick={() => onClose()}>{t("cancel")}</AlertDialogCancel>
          <AlertDialogAction
            disabled={loading || disableConfirmButton}
            className={confirmButtonClassName}
            onClick={onConfirm}
          >
            {confirmButtonLabel}
            {loading && <Loader2 className="mr-2 size-4 animate-spin" />}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
